if (!customElements.get('share-button')) {
  class ShareButton extends DetailsModal {
    constructor() {
      super();
      this.content = this.querySelector('[data-share-content]');
      this.shareLinks = this.querySelectorAll('[data-share-link]');
      this.isVertical = parseBooleanAttribute(this.getAttribute('vertical'));
      this.mql = window.matchMedia('(max-width: 749px)');
    }

    // TODO: Adjust elastic config with dev tools (probably blend eases — power2.in => elastic.out)
    buildTimeline() {
      if (this.timeline) this.timeline.kill();

      this.timeline = gsap.timeline({
        paused: true,
        onStart: this.handleTimelineStart,
        onReverseComplete: this.handleTimelineReverseComplete,
      });

      // TODO: Implement this better
      if (this.closest('lookbook-modal') && this.isVertical && this.mql.matches) {
        this.timeline.from(
          this.content,
          {
            height: 0,
            duration: 0.5,
            // ease: 'power2.out',
          },
          0
        );
      }

      this.timeline.fromTo(
        this.shareLinks,
        {
          autoAlpha: 0,
          scale: 0.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.5,
          stagger: {
            each: 0.05,
            from: 'end',
            axis: this.isVertical ? 'y' : 'x',
            grid: this.isVertical ? [this.shareLinks.length, 1] : [1, this.shareLinks.length],
          },
          ease: 'elastic.out(1, 1)',
        }
      );

      if (this.isOpen()) {
        this.timeline.progress(1);
      }
    }
  }

  customElements.define('share-button', ShareButton);
}

if (!customElements.get('web-share-button')) {
  class WebShareButton extends HTMLElement {
    constructor() {
      super();

      this.init()
    }

    async init() {
      this.shareData = {
        url: this.dataset.url,
        title: this.dataset.title,
        text: this.dataset.text,
      }

      if (this.dataset.image) {
        let imageType = this.dataset.image.split('.').pop().split('?').shift();
        if (imageType === 'jpg') imageType = 'jpeg';
        if (imageType === 'svg') imageType = 'svg+xml';

        const imageBlob = await fetch(this.dataset.image).then(res => res.blob());
        const data = {
          ...this.shareData,
          files: [
            new File([imageBlob], `${this.dataset.imageTitle}.${imageType}`, { type: `image/${imageType}` }),
          ],
        }

        if (navigator.canShare(data)) {
          this.shareData = data;
        }
      }

      if (!navigator.canShare || !navigator.canShare(this.shareData)) {
        const container = this.closest('[data-web-share-wrapper]') ?? this;
        container.style.display = 'none';
      }
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
      e.preventDefault();
      try {
        navigator.share(this.shareData);
      } catch (error) {
        console.error('Web Share failed', error);
      }
    }
  }

  customElements.define('web-share-button', WebShareButton);
}

if (!customElements.get('pin-it')) {
  class PinterestButton extends ElementBase {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.addListener(this.button, 'click', this.pinIt.bind(this));
    }

    defaults() {
      return {
        pinMedia: null,
        pinUrl: null,
        pinDescription: null,
      };
    }

    static get observedAttributes() {
      return ['pin-media', 'pin-url', 'pin-description'];
    }

    pinIt() {
      const { pinMedia: media, pinUrl: url, pinDescription: description } = this.options;

      if (!PinUtils) {
        this.log('Pin It: Pin creation failed, PinUtils not found.');
        return;
      }

      if (!url) {
        this.log('Pin It: Pin creation failed, no share URL provided.');
        return;
      }

      PinUtils.pinOne({ url, media, description });
    }
  }

  customElements.define('pin-it', PinterestButton);
}